/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_67a786f9{border:0;outline:0;width:100%}.editingInput_67a786f9::-ms-clear{display:none}.editingContainer_67a786f9{margin:4px}"}]);
export const editingInput = "editingInput_67a786f9";
export const editingContainer = "editingContainer_67a786f9";